export const getHeaders = () => {
  const token = localStorage.getItem('token') // or wherever you store it

  return {
    'Content-Type': 'application/json',
    Authorization: token ? `Bearer ${token}` : '',
  }
}
